import { ReportsList as ReportsListModule } from "../modules/MonthlyReports/ReportsList/ReportsList";

const MonthlyReports = () => {
  return <ReportsListModule />;
};

export default MonthlyReports;
